export function money(cents: number, currency = "USD"): string {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency,
  }).format(cents / 100);
}

/** Beside a negative payable balance (a refunded fee that was already paid). */
export const OWED_TO_US_NOTE =
  "This comes off your next fees before they are paid.";

/** "14 Oct 2026" from an ISO date or timestamp, in UTC. */
export function shortDate(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  return `${d.getUTCDate()} ${MONTHS_SHORT[d.getUTCMonth()]} ${d.getUTCFullYear()}`;
}

/** Spelled out by hand: Intl's en-GB short month became "Sept" in newer ICU. */
const MONTHS_SHORT = [
  "Jan",
  "Feb",
  "Mar",
  "Apr",
  "May",
  "Jun",
  "Jul",
  "Aug",
  "Sep",
  "Oct",
  "Nov",
  "Dec",
] as const;

let regionNames: Intl.DisplayNames | null | undefined;

/** "Germany" for "DE"; anything that is not a known ISO-2 code comes back as is. */
export function countryName(code: string): string {
  if (!/^[A-Z]{2}$/.test(code)) return code;
  if (regionNames === undefined) {
    try {
      regionNames = new Intl.DisplayNames(["en"], { type: "region" });
    } catch {
      regionNames = null;
    }
  }
  const name = regionNames?.of(code);
  // CLDR names reserved and user-assigned codes "Unknown Region".
  if (!name || name === code || /unknown region/i.test(name)) return code;
  // Plain Latin letters only ("Türkiye" → "Turkiye").
  return name
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .replace(/[\u2018\u2019]/g, "'");
}

/** "5 Nov 2026, 15:00 UTC" from an ISO timestamp. */
export function shortDateTime(iso: string | null | undefined): string {
  if (!iso) return "";
  const d = new Date(iso);
  if (Number.isNaN(d.getTime())) return "";
  const hh = String(d.getUTCHours()).padStart(2, "0");
  const mm = String(d.getUTCMinutes()).padStart(2, "0");
  return `${shortDate(iso)}, ${hh}:${mm} UTC`;
}
